<style scoped>

  .required .control-label:after {
    content: "*";
    color: red;
    margin-left: 0.2em;
  }

  .g-recaptcha {
    display: inline-block;
    margin-top: 1.5em;
    margin-bottom: 1.5em;
  }

  .btn {
    padding: 0.6em 0.8em
  }

  .form-footer {
    background-color: #0F5784;
    padding: 40px
  }

  .form-header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    margin-bottom: 10px;
  }

  .form-header_logo {
    width: 180px;
    margin-bottom: 10px;
  }

  .form-title {
    font-size: 1.5em;
    font-weight: 400;
    text-align: center;
    margin-bottom: 20px;
  }

  .btn-primary, .btn-primary:active {
    background-color: #FFB400 !important;
    border-color: #FFB400 !important;
    outline: none !important;
  }

  .btn-primary:hover {
    background-color: #E3A544 !important;
    border-color: #E3A544 !important;
    outline: none !important;
  }

  .btn-primary:disabled {
    background-color: #ffc642 !important;
    border-color: #ffc642 !important;
    outline: none !important;
  }

  .btn-primary:focus {
    background-color: #E9B154 !important;
    border-color: #E9B154 !important;
    outline: none !important;
    box-shadow: none !important;
  }

  .btn-danger:focus {
    outline: none !important;
    box-shadow: none !important;
  }

</style>

<template>
  <b-container>
    <b-row class="vh-100 justify-content-center align-items-center">
      <b-col sm="12" md="10" lg="8" >
        <b-card class="rounded-0">
          <b-card-body>
            <div class="form-header">
              <b-link href="https://artenara.es/portal-ciudadano/">
                <img src="../assets/ayto-artenara-logo.jpg" alt="Logo del Ayuntamiento de Artenara" class="form-header_logo img-fluid">
              </b-link>
            </div>
            <b-form @submit.prevent="onSubmit">
              <h1 class="form-title">Verificación de Certificado de Viajes</h1>
              <b-alert
                :show="dismissCountDown"
                fade
                variant="danger"
                @dismiss-count-down="countDownChanged"
              >
                {{ errorMessage }}
              </b-alert>
              <div class="form-body">
                <div class="row">
                  <div class="col-lg-12">
                    <b-form-group class="required">
                      <label for="csv" class="control-label">Código Seguro de Verificación</label>
                      <b-form-input 
                        id="csv" 
                        v-model.trim="$v.form.csv.$model"
                        :state="validateState('csv')" 
                        @blur="$v.form.csv.$touch()"  
                        aria-describedby="csv"
                        autocomplete="off"
                      ></b-form-input>
                      <b-form-invalid-feedback id="csv">
                        <p v-if="!$v.form.csv.required">
                          Debe introducir el Código Seguro de Verificación asociado al certificado.
                        </p>
                      </b-form-invalid-feedback>  
                    </b-form-group>
                    <div class="text-center">
                      <vue-recaptcha ref="recaptcha" sitekey="6LdBHxcpAAAAAOxsQ-1dJHRCtNRSbxnPTguPNxY5" :loadRecaptchaScript="true"  @verify="verifyRecaptcha" @expired="expiredRecaptcha" @error="errorRecaptcha" class="g-recaptcha"></vue-recaptcha>
                    </div>
                    <div class="text-center">
                      <b-button class="mr-2" type="submit" variant="primary" :disabled="$v.$invalid"><b-spinner class="mr-2" small v-if="loading"></b-spinner><span v-if="loading">Verificando certificado</span><span v-else><font-awesome-icon class="mr-2" :icon="['fas', 'file']" />Verificar certificado</span></b-button>
                      <b-button class="mr-2" @click="resetForm" variant="danger"><span><font-awesome-icon class="mr-2" :icon="['fas', 'undo']" />Borrar todo</span></b-button>
                      <b-button :to="{ name: 'GenerateCertificate' }" variant="info"><span><font-awesome-icon class="mr-2" :icon="['fas', 'arrow-left']" />Volver</span></b-button>
                    </div>
                  </div>
                </div>
              </div>
            </b-form>
          </b-card-body>
        </b-card>
        <div class="form-footer"></div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { validationMixin } from "vuelidate";
import axios from "axios";

const date = helpers.regex('date', /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/);

import {
  required
} from "vuelidate/lib/validators";

import { helpers } from 'vuelidate/lib/validators';

import VueRecaptcha from 'vue-recaptcha'


export const AWS_API_KEY = process.env.VUE_APP_AWS_API_KEY;
export const AWS_API_URL = process.env.VUE_APP_AWS_VERIFY_CERTIFICATE_API_URL;
export const RECAPTCHA_SITE_KEY = process.env.VUE_APP_RECAPTCHA_SITE_KEY;

export default {
  name: "VerifyCertificate",
  data() {
    return {
      form: {
        csv: '',
      },
      error: false,
      errorMessage: '',
      loading: false,
      success: false,
      dismissSecs: 25,
      dismissCountDown: 0,
      recaptchaVerified: false,
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      csv: {
        required,
      },
    }
  },
  methods: {
    validateState(name) {

      const { $dirty, $error } = this.$v.form[name];
      return !$error && null;

    },
    onSubmit() {

      this.$v.$touch();

      if (!this.$v.$invalid) {
        
        if (!this.recaptchaVerified) {
          this.errorMessage = "Debes completar el reCAPTCHA.";
          this.showAlert();
          return;
        }

        this.loading = true;
        
        const body = JSON.stringify(
          {
              csv: this.form.csv,
          }
        );

        axios.post(
          AWS_API_URL,
          body,
          {
            headers: {
              'X-Api-Key': AWS_API_KEY,
              'Content-Type': 'application/json'
            },
          }
        )
        .then(
          (response) => {

            this.reset();
            this.success = true;

            if (response.data.statusCode == 200) {

              var pdfURL = `data:application/pdf;base64,${response.data.body}`;
              var pdfLink = document.createElement('a');

              pdfLink.href = pdfURL;
              pdfLink.setAttribute('download', 'certificate.pdf');
              document.body.appendChild(pdfLink);
              pdfLink.click();
              document.body.removeChild(document.body.lastChild);

            } else  if (response.data.statusCode == 404 || response.data.statusCode == 500) {

              this.errorMessage = response.data.error.message;
              this.showAlert();

            }

          }
        )
        .catch(
          (error) => {
            this.error = true;
            console.log(error);
          }
        )
        .finally(
          () => {
            this.loading = false;
          }
        )
      }
    },
    reset() {
      this.$v.$reset();
      this.success = false;
      this.error = false;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    verifyRecaptcha(response) {
      if (response) {
        this.recaptchaVerified = true
      }
    },
    expiredRecaptcha() {
      this.recaptchaVerified = false
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset()
      this.recaptchaVerified = false
    },
    errorRecaptcha() {
      this.recaptchaVerified = false
    },
    resetForm() {
      // Reseteamos las validaciones de Vuelidate
      this.$v.$reset();
      // Reseteamos el valor de los atributos del modelo Formulario
      this.form.csv = '';
      // Reseteamos el reCAPTCHA
      this.resetRecaptcha();
    },
  },
  components: {
    VueRecaptcha
  }
}
</script>


// WEBPACK FOOTER //
// src/views/VerifyCertificate.vue